<template>
  <div>
    <create-menu-component
      :shop="shop"
      :salepageId="salepageId"
      @onStore="getMenu()"
    ></create-menu-component>

    <div class="tw-mt-5">
      <div class="table-responsive">
        <table class="table table-hover mt-3 mb-0 c_list">
          <thead>
            <tr>
              <th>ชื่อเมนู</th>

              <th>ประเภท</th>

              <th>Link</th>

              <th colspan="3"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="menus.length === 0">
              <td class="text-center" colspan="5">
                <span class="tw-my-3"> ไม่พบเมนู </span>

                <div class="tw-flex tw-justify-center tw-mt-2">
                  <create-menu-component
                    :shop="shop"
                    :salepageId="salepageId"
                    @onStore="getMenu()"
                  ></create-menu-component>
                </div>
              </td>
            </tr>

            <tr v-for="(item, index) in menus" :key="index">
              <td class="">{{ item.title }}</td>

              <td>{{ link_type[item.link_type] }}</td>

              <td>
                <span v-if="item.link_type == 'external'">
                  {{ item.link }}
                </span>
                <span v-else-if="item.link_type == 'category'">
                  <i :class="`fa ${item.link.icon}`"></i> {{ item.link.title }}
                </span>
              </td>

              <td class="tw-flex tw-justify-end">
                <edit-menu-component
                class="tw-mr-1"
                  :shop="shop"
                  :salepageId="salepageId"
                  :menu="item"
                  @onUpdate="getMenu()"
                ></edit-menu-component>

                <delete-menu-component
                  class="tw-mr-1"
                  :shop="shop"
                  :salepageId="salepageId"
                  :menu="item"
                  @onUpdate="getMenu()"
                ></delete-menu-component>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["shop", "salepageId"],
  data() {
    return {
      loading: false,
      menus: [],
      link_type: {
        'home' : 'หน้าหลัก',
        'category' : 'หมวดหมู่',
        'external' : 'ลิงค์ภายนอก',
      }
    };
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    getMenu() {
      this.loading = true;
      axios
        .get(`/ajax/frontend/s/${this.shop}/salepage/${this.salepageId}/menu`)
        .then((res) => {
          this.menus = res.data.menus;
          this.loading = false;
        });
    },
  },
};
</script>

